const normalize = (value = '') => String(value || '').replace(/\s+/g, ' ').trim();

export const buildFriendlyDocumentTitle = (fileName = '') => normalize(
  String(fileName || '')
    .replace(/\.[^.]+$/, '')
    .replace(/^[0-9]+[_\s-]+/, '')
    .replace(/[_-]+/g, ' ')
);

export const getDocumentOriginSuggestion = (result = {}) => normalize(
  result.sourceOriginSuggestion?.name
  || result.sourceMetadata?.sourceOriginSuggestion?.name
  || result.sourceName
);
